// extracted by mini-css-extract-plugin
export default {"DateTime":"style_DateTime__bD1mo","Label":"style_Label__vQ1xm","TimeGroup":"style_TimeGroup__USClN","Separator":"style_Separator__Qd1C4","Input":"style_Input__QMLKW"};